import { useContext, useEffect } from 'react';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from '@/components/ui/select';
import { Globe } from 'lucide-react';
import { LanguageContext } from '../../../context/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <Select onValueChange={handleLanguageChange} defaultValue={language}>
      <SelectTrigger className="w-[70px] bg-gray-900 text-white border-none mt-0.5">
        <Globe className="h-6 w-7" color="white" />
      </SelectTrigger>
      <SelectContent className="bg-gray-900 text-white border-none">
        <SelectItem value="en">EN</SelectItem>
        <SelectItem value="bg">BG</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
